import { useMemo } from 'react';
import { useAuth } from '../auth/auth-context';
import { useMembers, useToggleFavorite } from '../hooks/use-members';

export function MembersPage() {
  const { user: me } = useAuth();
  const members = useMembers();
  const toggle = useToggleFavorite();

  // Client-seitiges Sort als Backup mit localeCompare fuer korrekte Umlaut-Reihenfolge
  const sorted = useMemo(
    () =>
      members.data
        ? [...members.data].sort((a, b) =>
            a.firstName.localeCompare(b.firstName, 'de', {
              sensitivity: 'base',
            }),
          )
        : [],
    [members.data],
  );

  return (
    <div className="px-4 py-4 space-y-3">
      <h1 className="text-xl font-semibold">Mitglieder</h1>

      {members.isLoading ? (
        <p className="py-12 text-center text-sm text-slate-400">Lädt …</p>
      ) : members.error ? (
        <p className="py-12 text-center text-sm text-rose-400">
          Fehler beim Laden
        </p>
      ) : sorted.length > 0 ? (
        <ul className="divide-y divide-slate-800 rounded-xl border border-slate-800 bg-slate-900/60">
          {sorted.map((m) => {
            const isSelf = me?.id === m.id;
            const tel = m.mobilePhone?.replace(/\s/g, '');
            return (
              <li key={m.id} className="flex items-center gap-3 p-3">
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium truncate">
                    {m.firstName} {m.lastName}
                    {isSelf && (
                      <span className="ml-2 text-xs font-normal text-slate-500">
                        (du)
                      </span>
                    )}
                  </p>
                  <p className="mt-0.5 text-xs text-slate-400 truncate">
                    <a
                      href={`mailto:${m.email}`}
                      className="hover:text-brand-300"
                    >
                      {m.email}
                    </a>
                    {tel && (
                      <>
                        <span className="mx-1.5 text-slate-600">|</span>
                        <a
                          href={`tel:${tel}`}
                          className="hover:text-brand-300"
                        >
                          {m.mobilePhone}
                        </a>
                      </>
                    )}
                  </p>
                </div>
                {!isSelf && (
                  <button
                    onClick={() =>
                      toggle.mutate({
                        userId: m.id,
                        favorite: !m.isFavorite,
                      })
                    }
                    aria-label={
                      m.isFavorite ? 'Favorit entfernen' : 'Als Favorit markieren'
                    }
                    title={
                      m.isFavorite ? 'Favorit entfernen' : 'Als Favorit markieren'
                    }
                    className={`h-9 w-9 shrink-0 rounded-full text-lg transition-colors ${
                      m.isFavorite
                        ? 'bg-amber-900/30 text-amber-300 hover:bg-amber-900/50'
                        : 'bg-slate-800 text-slate-500 hover:bg-slate-700 hover:text-slate-300'
                    }`}
                  >
                    {m.isFavorite ? '★' : '☆'}
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      ) : (
        <p className="py-12 text-center text-sm text-slate-400">
          Keine Mitglieder gefunden.
        </p>
      )}
    </div>
  );
}
